import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, ButtonProps } from '@mui/material';

interface NavigateDetailProductButtonProps extends ButtonProps {
  label?: string;
}

export function NavigateDetailProductButton({
  label = '詳細を見る',
  ...props
}: NavigateDetailProductButtonProps) {
  return (
    <Button
      variant="outlined"
      endIcon={<ArrowForwardIcon />}
      sx={{
        '&:hover': {
          backgroundColor: '#3187E1',
          borderColor: '#3187E1',
          color: 'white',
        },
        borderColor: '#3187E1',
        borderRadius: 15,
        color: '#3187E1',
        fontSize: '20px',
        fontWeight: 'bold',
        minWidth: '168px',
        p: '5px 20px',
      }}
      {...props}
    >
      {label}
    </Button>
  );
}
